import { Route } from '@angular/router';
import { AuthGuard } from './core/auth/guard/auth.guard';

export const appRoutes = {
  auth: 'auth',
  modules: 'modules'
}

export const AppRoutes: Route[] = [
  {
    path: appRoutes.modules,
    loadChildren: () => import('./modules/home.routes').then((x) => x.FEATURE_ROUTES),
    canActivate: [AuthGuard]
  },
  {
    path: appRoutes.auth,
    loadChildren: () => import('./modules/authorization/authorization.routes').then((x) => x.AuthorizationRoutes)
  },
  {
    path: '**',
    redirectTo: appRoutes.modules,
  }
];